import SideBarBlog from "@/components/Blogs/SideBarBlog";
import { UserDetailProvider } from "@/contexts/UserDetailContext";
import MetaSection from "@/elements/MetaSection/MetaSection";
import { Mixpanel } from "@/elements/Mixpanel";
import { cn } from "@/lib/utils";
import axios from "axios";
import { ChevronRight } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useContext, useEffect } from "react";

export default function WebStories({ data, category }) {
    const router = useRouter();
    const userDetail = useContext(UserDetailProvider);
    useEffect(() => {
        Mixpanel.pageView({
            page: "web_stories_home"
        });
        userDetail.setBtn({
            show: router?.query?.webview ? false : true,
            beforeLogin: "Activate trial",
            afterLogin: "Download the app now",
            isProPage: true,
            page: "web_stories_home"
        });
        localStorage.setItem("webview", router?.query?.webview ? "true" : "false");
    }, []);
    return (
        <div className="pt-24 relative">
            <MetaSection
                title="Stock Market News & Webstories | Share Market Daily Updates"
                desc="Get daily updates of stock market news with Univest web stories."
                schema={{
                    "@context": "https://schema.org",
                    "@graph": [
                        {
                            "@type": ["Person", "Organization"],
                            "@id": "https://univest.in/web-stories/#person",
                            name: "Univest",
                            logo: {
                                "@type": "ImageObject",
                                "@id": "https://univest.in/web-stories/#logo",
                                url: "https://univest.in/web-stories/wp-content/uploads/2023/12/left-logo.png",
                                contentUrl: "https://univest.in/web-stories/wp-content/uploads/2023/12/left-logo.png",
                                caption: "https://univest.in/",
                                inLanguage: "en-US",
                                width: "187",
                                height: "45"
                            },
                            image: {
                                "@type": "ImageObject",
                                "@id": "https://univest.in/web-stories/#logo",
                                url: "https://univest.in/web-stories/wp-content/uploads/2023/12/left-logo.png",
                                contentUrl: "https://univest.in/web-stories/wp-content/uploads/2023/12/left-logo.png",
                                caption: "https://univest.in/",
                                inLanguage: "en-US",
                                width: "187",
                                height: "45"
                            }
                        },
                        {
                            "@type": "WebSite",
                            "@id": "https://univest.in/web-stories/#website",
                            url: "https://univest.in/web-stories",
                            name: "https://univest.in/",
                            publisher: { "@id": "https://univest.in/web-stories/#person" },
                            inLanguage: "en-US",
                            potentialAction: {
                                "@type": "SearchAction",
                                target: "https://univest.in/web-stories/?s={search_term_string}",
                                "query-input": "required name=search_term_string"
                            }
                        },
                        {
                            "@type": "WebPage",
                            "@id": "https://univest.in/web-stories/#webpage",
                            url: "https://univest.in/web-stories/",
                            name: "Univest Web Stories - #1 Financial Web Web Stories Covering Trending Topics",
                            datePublished: "2024-01-05T12:50:44+05:30",
                            dateModified: "2024-02-06T14:42:04+05:30",
                            about: { "@id": "https://univest.in/web-stories/#person" },
                            isPartOf: { "@id": "https://univest.in/web-stories/#website" },
                            inLanguage: "en-US"
                        },
                        {
                            "@type": "Person",
                            "@id": "https://univest.in/web-stories/#author",
                            name: "Avneet Dhamija",
                            image: {
                                "@type": "ImageObject",
                                "@id": "https://secure.gravatar.com/avatar/4b244dec68772ad327eead8f5575ec8f?s=96&amp;d=mm&amp;r=g",
                                url: "https://secure.gravatar.com/avatar/4b244dec68772ad327eead8f5575ec8f?s=96&amp;d=mm&amp;r=g",
                                caption: "Avneet Dhamija",
                                inLanguage: "en-US"
                            }
                        },
                        {
                            "@type": "Article",
                            headline: "Stock Market News & Webstories | Share Market Daily Updates",
                            keywords: "univest Web Stories",
                            datePublished: "2024-01-05T12:50:44+05:30",
                            dateModified: "2024-02-06T14:42:04+05:30",
                            author: { "@id": "https://univest.in/web-stories/#author", name: "Avneet Dhamija" },
                            publisher: { "@id": "https://univest.in/web-stories/#person" },
                            description:
                                "Get pre & post share market updates, top gainer & loser of the day share name & many more.",
                            name: "Stock Market News & Webstories | Share Market Daily Updates",
                            "@id": "https://univest.in/web-stories/#richSnippet",
                            isPartOf: { "@id": "https://univest.in/web-stories/#webpage" },
                            inLanguage: "en-US",
                            mainEntityOfPage: { "@id": "https://univest.in/web-stories/#webpage" }
                        }
                    ]
                }}
            />
            <h1 className="text-3xl font-bold text-center mb-10">Web Stories</h1>
            <div className="flex gap-6 font-Inter max-w-screen-xl mx-auto px-4 mb-6 items-start">
                <div className="w-full">
                    {category?.map((ele, i) => {
                        let filterList = data?.filter((f) => f.web_story_category?.includes(ele?.id))?.slice(0, 3);
                        return (
                            <div key={i}>
                                <div className="flex items-center justify-between mb-5">
                                    <h2 className="text-xl font-bold rounded text-black">{ele?.name}</h2>
                                    <button
                                        onClick={() => {
                                            Mixpanel.track("cta_clicked", {
                                                page: "web_stories_home"
                                            });
                                            router.push(`/web-stories/category/${ele?.slug}`);
                                        }}
                                        className="flex items-center text-base text-primary font-bold"
                                        aria-label={`View more about ${ele?.name}`}
                                    >
                                        View more <ChevronRight aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="grid grid-cols-1 lg:grid-cols-3 grid-flow-row gap-x-6 gap-y-8 mb-6">
                                    {filterList?.length > 0 ? (
                                        filterList?.map((ele, i) => <WebStoryCard data={ele} key={i} />)
                                    ) : (
                                        <div className="w-full text-center p-6 border rounded-xs mb-5 shadow">
                                            No data found
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className={cn(`min-w-[256px] w-[256px] sticky top-32 hidden lg:block`)}>
                    <Link href="/user/log-in">
                        <img
                            src="https://storage.googleapis.com/production-univest/pn_images/1732781423354_losing-money-web-512x550-new.jpg"
                            alt="ad"
                            className={cn("rounded-2xl cursor-pointer")}
                            loading="lazy"
                        />
                    </Link>
                    <SideBarBlog item={{ categories: [845, 19, 865, 24, 842, 1] }} />
                </div>
            </div>
        </div>
    );
}

export function WebStoryCard({ data }) {
    const { push } = useRouter();
    return (
        <div className="w-full">
            <img
                onClick={() => {
                    Mixpanel.track("page_view", {
                        page: "web_stories_home"
                    });
                    push(`/web-stories/${data?.slug}`);
                }}
                src={data?.story_poster?.url}
                alt={data?.title?.rendered}
                className="w-full rounded-xl border border-[#BCBCBC] shadow object-contain cursor-pointer transition-all duration-300 hover:scale-[101%]"
            />
            <h2 className="text-base font-semibold my-3 lg:my-4 line-clamp-1">{data?.title?.rendered}</h2>
            <div
                className="text-sm font-medium text-[#747474] line-clamp-4"
                dangerouslySetInnerHTML={{ __html: data?.excerpt?.rendered }}
            />
            <div
                className="text-sm font-bold text-primary/80 mt-3 lg:mt-4 underline cursor-pointer"
                onClick={() => push(`/web-stories/${data?.slug}`)}
            >
                Read more
            </div>
        </div>
    );
}

export async function getStaticProps() {
    var res = await axios.get(`https://univest.in/api/web-stories`).catch((err) => ({}));
    const data = res?.data?.data ?? [];
    const category = res?.data?.category ?? [];

    return {
        props: {
            data,
            category
        },
        revalidate: 60 * 60
    };
}
